// extracted by mini-css-extract-plugin
export var avatarContainer = "_4f-1";
export var largeAvatarContainer = "_4f-2";
export var smallAvatarContainer = "_4f-0";